var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"burger-menu",class:_vm.burger_menu_classes,attrs:{"role":"button","aria-label":"Toggle menu"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])
}
var staticRenderFns = []

export { render, staticRenderFns }